<template>
  <div class="row" v-if="enabled">
    <q-radio
      v-model="floatType"
      val="high_cap_stocks"
      label="High Cap"
      color="cyan"
      keep-color
      class="text-subtitle2"
    />
    <q-radio
      v-model="floatType"
      val="mid_cap_stocks"
      label="Mid Cap"
      color="cyan"
      keep-color
      class="text-subtitle2"
    />
    <q-radio
      v-model="floatType"
      val="low_cap_stocks"
      label="Low Cap"
      color="cyan"
      keep-color
      class="text-subtitle2"
    />
    <q-radio
      v-model="floatType"
      val="ultra_low_cap_stocks"
      label="Ultra Low Cap"
      color="cyan"
      keep-color
      class="text-subtitle2"
    />
    <q-radio
      v-model="floatType"
      val="all"
      label="All"
      color="cyan"
      keep-color
      class="text-subtitle2"
    />
  </div>
</template>

<script setup>
import { ref, watch } from "vue";

const emit = defineEmits(["floatType"]);
const defineProps = defineProps({
  enabled: {
    type: Boolean,
    default: true,
  },
});
const floatType = ref("all");

emit("floatType", floatType.value);

watch(floatType, (newVal, oldVal) => {
  emit("floatType", floatType.value);
});
</script>
